module.exports = __webpack_public_path__ + "static/media/accessoire.f8162a0f.png";